import { Routes, Route } from 'react-router-dom'
import { I18nProvider } from './hooks/I18nContext'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import Start from './pages/Start'
import Learning from './pages/Learning'
import Support from './pages/Support'
import Buy from './pages/Buy'
import About from './pages/About'

function App() {
  return (
    <I18nProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/start" element={<Start />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/support" element={<Support />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </Layout>
    </I18nProvider>
  )
}

export default App
